import React, { useEffect, useRef, useState } from "react";
import InsightsLeft from "../../../../assets/image/InsightsLeft.png";
import InsightsRight from "../../../../assets/image/InsightsRight.png";
import "animate.css";
import "./Insights.css";

const Insights = () => {
  const [isAnimated, setIsAnimated] = useState(false); // Track if animation has been applied
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isAnimated) {
          setIsAnimated(true); // Trigger animation only once
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [isAnimated]);

  return (
    <div className="home-section" ref={sectionRef}>
      <div className="overview-container">
        {/* Section Heading */}
        <div className={`heading ${isAnimated ? "animate__animated animate__pulse" : ""}`}>
          <h3 className="subtitle">Sales Analytics & Insights</h3>
          <h1>Turn Data Into Growth</h1>
        </div>

        {/* Content Section */}
        <div className="insights-content">
          {/* Left Text and Image */}
          <div className="insights-text-content row" style={{ overflow: "hidden" }}>
            <img
              className={`col-12 col-sm-2 ${isAnimated ? "animate__animated animate__fadeInLeft animate__delay-1s" : ""}`}
              src={InsightsLeft}
              alt="Insights Left"
            />
            <div
              className={`text-end col-12 col-sm-9 ${isAnimated ? "animate__animated animate__fadeInLeft animate__delay-1s" : ""}`}
            >
              <h3>Optimize Your Sales</h3>
              <p className="highlight">
                Gain deep insights into your orders, customer preferences, and trending products. Use data to refine your strategy and target the right audience.
              </p>
            </div>
          </div>

          {/* Right Text and Image */}
          <div className="insights-text-content row" style={{ overflow: "hidden" }}>
            <div
              className={`text-start col-12 col-sm-9 ${isAnimated ? "animate__animated animate__fadeInRight animate__delay-1s" : ""}`}
            >
              <h3>Smart Decisions, Better Results</h3>
              <p className="highlight">
                Track sales performance, analyze demand patterns, and make informed decisions to maximize profitability and business growth.
              </p>
            </div>
            <img
              className={`col-12 col-sm-2 ${isAnimated ? "animate__animated animate__fadeInRight animate__delay-1s" : ""}`}
              src={InsightsRight}
              alt="Insights Right"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Insights;
